export default __webpack_public_path__ + "static/media/perspective-dice-six-faces-six.b09ae5d2.png";